<template>
  <div class="mt-4 space-y-5 divide-y divide-gray-900/10">
    <div class="grid grid-cols-1 gap-8 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">{{ kbStore.kbTypeTitle }}</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Specify name and description for the Knowledge Base</p>
        </div>
      </div>

      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-6">
            <div class="sm:col-span-4">
              <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Name</label>
              <div class="mt-2">
                <div class="flex rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-indigo-600 sm:max-w-md">
                  <input
                    id="name"
                    v-model="specName"
                    type="text"
                    name="name"
                    class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Specify KB Name"
                  />
                </div>
              </div>
            </div>

            <InputTextarea v-model="specDescription" class="col-span-full" name="description" label="Description" placeholder="Provide brief description of the KB"></InputTextarea>

            <div class="col-span-full">
              <label for="name" class="block text-sm font-medium leading-6 text-gray-900">Tags</label>
              <div class="text-xs text-gray-500">List of Tags that can be set on KB Documents</div>
              <StdTagInputEditor v-model="specTags" class="mt-2" :available-tags="kbStore.kbTags" @add-tag="onKbAddTag"></StdTagInputEditor>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Web Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Load data from the Web, for example from your website.</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup v-model="webSourceEnabled" :disabled="true" class="col-span-full" :name="propsDefs['webSourceEnabled'].title" :description="propsDefs['webSourceEnabled'].description">
              <div class="mt-4 grid max-w-2xl grid-cols-1 gap-x-6 gap-y-2 border-l-2 border-indigo-100 pl-4 sm:grid-cols-6">
                <InputTextarea
                  v-model="sitemaps"
                  class="col-span-full"
                  name="sitemaps"
                  :label="propsDefs['sitemaps'].title"
                  :description="propsDefs['sitemaps'].description"
                  :placeholder="propsDefs['sitemaps'].placeholder"
                  :rows="2"
                ></InputTextarea>

                <InputTextarea
                  v-model="urls"
                  class="col-span-full"
                  name="urls"
                  :label="propsDefs['urls'].title"
                  :description="propsDefs['urls'].description"
                  :placeholder="propsDefs['urls'].placeholder"
                  :rows="2"
                ></InputTextarea>
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>

    <div v-if="settingsStore.salesforceIntegrationEnabled" class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Salesforce Help Center Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Enable load data from your Salesforce Help Centers</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup
              v-model="salesforceHelpCenterSourceEnabled"
              class="col-span-full"
              :name="propsDefs['salesforceHelpCenterSourceEnabled'].title"
              :description="propsDefs['salesforceHelpCenterSourceEnabled'].description"
            >
              <ToggleGroup v-model="salesforceFieldMapperEnabled" class="col-span-full" :name="salesforceFieldMapperEnabled ? 'Switch to Default fields' : 'Switch to Custom fields'"></ToggleGroup>
              <template v-if="salesforceFieldMapperEnabled">

                <div class="mt-2">
                  <div class="col-span-full">
                    <label class="block text-sm font-medium leading-6 text-gray-900">Custom Fields</label
                    ><!---->
                    <div v-for="(item, idx) in contactFormFields" :key="idx" class="relative my-2 grid grid-cols-1 gap-4 rounded-lg border p-2 sm:grid-cols-6 md:col-span-2">
                      <div class="sm:col-span-full md:col-span-full lg:col-span-3">
                        <label for="objectType" class="block text-sm font-medium leading-6 text-gray-900">Custom Object Type</label
                        ><!---->
                        <div class="mt-2">
                          <Dropdown
                            v-model="item.objectType"
                            :disabled="false"
                            :options="allObjects"
                            filter
                            option-label="searchableLabel"
                            option-value="name"
                            placeholder="Select..."
                            class="md:w-14rem w-full"
                            :class="{ 'ring-1 ring-red-500 focus:ring-1 focus:ring-red-500': false }"
                            @change="() => changeObjectType(item)"
                          >
                            <template #option="slotProps">
                              <div class="flex flex-col">
                                <span>{{ slotProps.option.label }}</span>
                                <span class="text-xs text-gray-500">{{ slotProps.option.name }}</span>
                              </div>
                            </template>
                            <template #value="{ value }">
                              <div class="flex flex-col">
                                <span>{{ allObjects.find((o) => o.name === value)?.label }}</span>
                                <span class="text-xs text-gray-500">{{ value }}</span>
                              </div>
                            </template>
                          </Dropdown>
                        </div>
                      </div>
                      <div class="col-span-full">
                        <div class="grid grid-cols-1 sm:grid-cols-6 gap-x-4 text-sm text-gray-700 mt-2 mb-[-2px] pl-1">
                          <div class="sm:col-span-3">Field</div>
                          <div class="sm:col-span-3">Mapped Field</div>
                        </div>
                        <div v-for="(field, fIdx) in fieldsMappingArray(item)" :key="fIdx" class="relative my-2 grid grid-cols-1 gap-4 rounded-lg border p-2 sm:grid-cols-6 md:col-span-2">
                          <div class="sm:col-span-full md:col-span-full lg:col-span-3">
                            <div class="mt-2">
                              <Dropdown
                                v-model="field.type"
                                :disabled="true"
                                :options="requiredFieldTypes"
                                filter
                                option-label="label"
                                option-value="name"
                                placeholder="Select..."
                                class="md:w-14rem w-full"
                                :class="{ 'ring-1 ring-red-500 focus:ring-1 focus:ring-red-500': false }"
                              >
                                <template #option="slotProps">
                                  <div class="flex flex-col">
                                    <span>{{ slotProps.option.label }}</span>
                                    <span class="text-xs text-gray-500">{{ slotProps.option.name }}</span>
                                  </div>
                                </template>
                                <template #value="{ value }">
                                  <div class="flex flex-col">
                                    <span>{{ [...requiredFieldTypes, ...optionalFieldTypes].find((o) => o.name === value)?.label }}</span>
                                    <span class="text-xs text-gray-500">{{ value }}</span>
                                  </div>
                                </template>
                              </Dropdown>
                            </div>
                          </div>
                          <div class="sm:col-span-full md:col-span-full lg:col-span-3">
                            <div class="mt-2">
                              <Dropdown
                                v-model="field.field"
                                :disabled="false"
                                :options="fieldsByObjectTypeMap[item.objectType] || []"
                                filter
                                option-label="label"
                                option-value="name"
                                placeholder="Select..."
                                class="md:w-14rem w-full"
                                :class="{ 'ring-1 ring-red-500 focus:ring-1 focus:ring-red-500': !field.field }"
                                @change="
                                  (a) => {
                                    item.fieldsMapping[field.type] = a.value;
                                  }
                                "
                              >
                                <template #option="slotProps">
                                  <div class="flex flex-col">
                                    <span>{{ slotProps.option.label }}</span>
                                    <span class="text-xs text-gray-500">{{ slotProps.option.name }}</span>
                                  </div>
                                </template>
                                <template #value="{ value }">
                                  <div class="flex flex-col">
                                    <span>{{ (fieldsByObjectTypeMap[item.objectType] || []).find((o) => o.name === value)?.label || 'Select field...' }}</span>
                                    <span class="text-xs text-gray-500">{{ value || '&nbsp;' }}</span>
                                  </div>
                                </template>
                              </Dropdown>
                            </div>
                          </div>
                          <button
                            v-if="optionalFieldTypes.some(o => o.name === field.type)"
                            type="button"
                            @click="deleteFieldFromMapping(item, field.type)"
                            class="absolute right-1 top-1 rounded-full border border-gray-400 bg-white p-1 text-gray-600 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"

                          >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="size-3">
                              <path fill-rule="evenodd" d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z" clip-rule="evenodd"></path>
                            </svg>
                          </button>
                        </div>
                        <div class="mt-2 flex justify-end">
                          <button
                            v-if="requiredFieldTypes.length + optionalFieldTypes.length !== fieldsMappingArray(item).length"
                            type="button"
                            @click="addOptionalField(item, fieldsMappingArray(item).length)"
                            class="rounded-full bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="size-4">
                              <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"></path>
                            </svg>
                          </button>
                        </div>
                      </div>
                      <button
                        type="button"
                        @click="contactFormFields.splice(idx, 1)"
                        class="absolute right-1 top-1 rounded-full border border-gray-400 bg-white p-1 text-gray-600 shadow-sm hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="size-3">
                          <path fill-rule="evenodd" d="M4 10a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 10Z" clip-rule="evenodd"></path>
                        </svg>
                      </button>
                    </div>
                    <div class="mt-2 flex justify-end">
                      <template v-if="!allObjects.length">⏳</template>
                      <button
                        v-if="allObjects.length"
                        type="button"
                        class="rounded-full bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                        @click="addContactFormField"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon" class="size-4">
                          <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                  <StdPropEditor v-model="salesforceHelpCenterRecordTypes" style="display: none" class="col-span-4 mt-2" :prop-def="propsDefs['salesforceHelpCenterRecordTypes']" />
                  <MultiSelect v-model="hcRecordTypesSelected" :options="hcRecordTypes" placeholder="Select Record Types" :max-selected-labels="3" class="w-full" />
                </div>
              </template>
              <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                <StdPropEditor v-model="salesforcePrivateArticlesEnabled" class="col-span-4 mt-2" :prop-def="propsDefs['salesforcePrivateArticlesEnabled']" />
              </div>
              <div class="col-span-full flex items-center justify-end gap-x-2 border-l-2 border-indigo-100 pl-4 pt-6">
                <Button label="Reload all" icon="pi pi-cloud-download" severity="secondary" :disabled="salesforceFieldMapperEnabled ? !contactFormFields.length || contactFormFields.some(item => Object.values(item.fieldsMapping || {}).some(v => !v)) : !hcRecordTypesSelected.length" @click="onDownloadSalesforceHelpCenters(true)" />
                <Button icon="pi pi-cloud-download" label="Load Updates" :disabled="salesforceFieldMapperEnabled ?  !contactFormFields.length || contactFormFields.some(item => Object.values(item.fieldsMapping || {}).some(v => !v)) : !hcRecordTypesSelected.length" @click="onDownloadSalesforceHelpCenters(false)" />
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>
    <div v-if="settingsStore.shopifyIntegrationEnabled" class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Shopify Help Center Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Enable load data from your Shopify Help Centers</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup v-model="shopifyHelpCenterSourceEnabled" class="col-span-full" :name="propsDefs['shopifyHelpCenterSourceEnabled'].title" :description="propsDefs['shopifyHelpCenterSourceEnabled'].description">
              <ToggleGroup v-model="shopifyHelpCenterSourceCodeEnabled" class="col-span-full" :name="shopifyHelpCenterSourceCodeEnabled ? 'Switch to Dropdowns' : 'Switch to Code'"></ToggleGroup>
              <template v-if="shopifyHelpCenterSourceCodeEnabled">
                <div class="mt-2">
                  <StdPropEditor v-model="shopifyCustomCode" :prop-def="propsDefs['shopifyCustomCode']" />
                </div>
              </template>
              <template v-else>
                <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                  <StdPropEditor v-model="shopifyHelpCenterRecordTypes" style="display: none" class="col-span-4 mt-2" :prop-def="propsDefs['shopifyHelpCenterRecordTypes']" />
                  <MultiSelect v-model="shopifyRecordTypesSelected" :options="shopifyRecordTypes" placeholder="Select Record Types" :max-selected-labels="3" class="w-full" />
                </div>
                <div v-if="shopifyRecordTypesSelected.includes('Products')" class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                  <StdPropEditor v-model="shopifyProductMetafieldDefinitions" style="display: none" class="col-span-4 mt-2" :prop-def="propsDefs['shopifyProductMetafieldDefinitions']" />
                  <MultiSelect
                    v-model="shopifyProductMetafieldDefinitionsSelected"
                    :options="shopifyProducts"
                    option-label="name"
                    option-value="name"
                    :placeholder="loadingShopifyProducts ? '⏳ Loading...' : 'Select Product Metafield Definitions'"
                    :loading="loadingShopifyProducts"
                    :disabled="loadingShopifyProducts"
                    class="w-full"
                  />
                </div>
                <div v-if="shopifyRecordTypesSelected.includes('Products')" class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                  <StdPropEditor v-model="shopifyProductSalesChannels" style="display: none" class="col-span-4 mt-2" :prop-def="propsDefs['shopifyProductSalesChannels']" />
                  <MultiSelect
                    v-model="shopifyProductSalesChannelsSelected"
                    :options="productSalesChannels"
                    option-label="name"
                    option-value="id"
                    :placeholder="loadingShopifyProductSalesChannels ? '⏳ Loading...' : 'Select Product Sales Channels'"
                    :loading="loadingShopifyProductSalesChannels"
                    :disabled="loadingShopifyProductSalesChannels"
                    class="w-full"
                  />
                </div>
              </template>
              <div class="col-span-full flex items-center justify-end gap-x-2 border-l-2 border-indigo-100 pl-4 pt-6">
                <Button label="Reload all" icon="pi pi-cloud-download" severity="secondary" :disabled="!shopifyRecordTypesSelected.length" @click="onDownloadShopifyHelpCenters(true)" />
                <Button icon="pi pi-cloud-download" label="Load Updates" :disabled="!shopifyRecordTypesSelected.length" @click="onDownloadShopifyHelpCenters(false)" />
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>

    <div v-if="settingsStore.freshdeskIntegrationEnabled" class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Freshdesk Help Center Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Load data from your Freshdesk Help Centers</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup
              v-model="freshdeskHelpCenterSourceEnabled"
              class="col-span-full"
              :name="propsDefs['freshdeskHelpCenterSourceEnabled'].title"
              :description="propsDefs['freshdeskHelpCenterSourceEnabled'].description"
            >
              <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                <StdPropEditor v-model="freshdeskCategoryIds" style="display: none" class="col-span-4 mt-2" :prop-def="propsDefs['freshdeskCategoryIds']" />
                <MultiSelect
                  v-model="freshdeskCategoryIdsSelected"
                  :options="freshdeskCategories"
                  option-label="name"
                  option-value="id"
                  :placeholder="loadingFreshdeskCategories ? '⏳ Loading...' : 'Select Solution Categories'"
                  :loading="loadingFreshdeskCategories"
                  :disabled="loadingFreshdeskCategories"
                  :max-selected-labels="3"
                  class="w-full"
                />
                <StdPropEditor v-model="freshdeskHelpCenterTags" class="col-span-4 mt-2" :prop-def="propsDefs['freshdeskHelpCenterTags']" />
                <StdPropEditor v-model="freshdeskIncludeDrafts" class="col-span-4 mt-2" :prop-def="propsDefs['freshdeskIncludeDrafts']" />
              </div>
              <div class="col-span-full flex items-center justify-end gap-x-2 border-l-2 border-indigo-100 pl-4 pt-6">
                <Button label="Reload all" icon="pi pi-cloud-download" severity="secondary" :disabled="!freshdeskCategoryIdsSelected.length" @click="onDownloadFreshdeskHelpCenters(true)" />
                <Button icon="pi pi-cloud-download" label="Load Updates" :disabled="!freshdeskCategoryIdsSelected.length" @click="onDownloadFreshdeskHelpCenters(false)" />
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>

    <!-- [sv2] DO NOT CHECK settingsStore.zendeskIntegrationEnabled here. Loading from Zendesk HC can be done without enabling integration, via public API -->
    <div class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Zendesk Help Center Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Load data from your Zendesk Help Centers</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup v-model="zendeskHelpCenterSourceEnabled" class="col-span-full" :name="propsDefs['zendeskHelpCenterSourceEnabled'].title" :description="propsDefs['zendeskHelpCenterSourceEnabled'].description">
              <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                <StdPropEditor v-model="zendeskHelpCentersSubdomains" class="col-span-4 mt-2" :prop-def="propsDefs['zendeskHelpCentersSubdomains']" />
                <!-- [sv2] Only loading private articles requires zendesk integration -->
                <StdPropEditor v-if="settingsStore.zendeskIntegrationEnabled" v-model="zendeskPrivateArticlesEnabled" class="col-span-4 mt-2" :prop-def="propsDefs['zendeskPrivateArticlesEnabled']" />
              </div>
              <div class="col-span-full flex items-center justify-end gap-x-2 border-l-2 border-indigo-100 pl-4 pt-6">
                <Button label="Reload all" icon="pi pi-cloud-download" severity="secondary" @click="onDownloadZendeskHelpCenters(true)" />
                <Button icon="pi pi-cloud-download" label="Load Updates" @click="onDownloadZendeskHelpCenters(false)" />
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>
    <div v-if="settingsStore.kustomerIntegrationEnabled" class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Kustomer Help Center Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Load data from your Kustomer Help Centers</p>
        </div>
      </div>
      <div v-if="settingsStore.kustomerIntegrationEnabled" class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup v-model="kustomerHelpCenterSourceEnabled" class="col-span-full" :name="propsDefs['kustomerHelpCenterSourceEnabled'].title" :description="propsDefs['kustomerHelpCenterSourceEnabled'].description">
              <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                <StdPropEditor v-model="kustomerPrivateArticlesEnabled" class="col-span-4 mt-2" :prop-def="propsDefs['kustomerPrivateArticlesEnabled']" />
              </div>
              <div class="col-span-full flex items-center justify-end gap-x-2 pl-4 pt-6">
                <Button label="Reload all" icon="pi pi-cloud-download" severity="secondary" @click="onDownloadKustomerHelpCenters(true)" />
                <Button icon="pi pi-cloud-download" label="Load Updates" @click="onDownloadKustomerHelpCenters(false)" />
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>
    <div v-if="settingsStore.gorgiasIntegrationEnabled" class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Gorgias Help Center Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Load data from your Gorgias Help Centers</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup v-model="gorgiasHelpCenterSourceEnabled" class="col-span-full" :name="propsDefs['gorgiasHelpCenterSourceEnabled'].title" :description="propsDefs['gorgiasHelpCenterSourceEnabled'].description">
              <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                <StdPropEditor v-model="gorgiasHelpCentersSubdomains" class="col-span-4 mt-2" :prop-def="propsDefs['gorgiasHelpCentersSubdomains']" />
              </div>
              <div class="col-span-full flex items-center justify-end gap-x-2 border-l-2 border-indigo-100 pl-4 pt-6">
                <Button label="Reload all" icon="pi pi-cloud-download" severity="secondary" @click="onDownloadGorgiasHelpCenters(true)" />
                <Button icon="pi pi-cloud-download" label="Load Updates" @click="onDownloadGorgiasHelpCenters(false)" />
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>

    <div v-if="settingsStore.intercomIntegrationEnabled" class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Intercom Help Center Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Load data from your Intercom Help Centers</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup v-model="intercomHelpCenterSourceEnabled" class="col-span-full" :name="propsDefs['intercomHelpCenterSourceEnabled'].title" :description="propsDefs['intercomHelpCenterSourceEnabled'].description">
              <div class="col-span-full flex items-center justify-end gap-x-2 border-l-2 border-indigo-100 pl-4 pt-6">
                <Button label="Reload all" icon="pi pi-cloud-download" severity="secondary" @click="onDownloadIntercomHelpCenters(true)" />
                <Button icon="pi pi-cloud-download" label="Load Updates" @click="onDownloadIntercomHelpCenters(false)" />
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>

    <div v-if="settingsStore.confluenceIntegrationEnabled" class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Confluence Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Load data from your Confluence</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup
              v-model="confluenceHelpCenterSourceEnabled"
              class="col-span-full"
              :name="propsDefs['confluenceHelpCenterSourceEnabled'].title"
              :description="propsDefs['confluenceHelpCenterSourceEnabled'].description"
            >
              <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                <StdPropEditor v-model="confluenceSpaceKeys" class="col-span-4 mt-2" :prop-def="propsDefs['confluenceSpaceKeys']" />
                <StdPropEditor v-model="confluenceLabels" class="col-span-4 mt-2" :prop-def="propsDefs['confluenceLabels']" />
              </div>
              <div class="col-span-full flex items-center justify-end gap-x-2 border-l-2 border-indigo-100 pl-4 pt-6">
                <Button label="Reload all" icon="pi pi-cloud-download" severity="secondary" @click="onDownloadConfluenceHelpCenters(true)" />
                <Button icon="pi pi-cloud-download" label="Load Updates" @click="onDownloadConfluenceHelpCenters(false)" />
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>

    <div v-if="settingsStore.guruIntegrationEnabled" class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Guru Help Center Data</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Load data from your Guru Help Centers</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <ToggleGroup v-model="guruHelpCenterSourceEnabled" class="col-span-full" :name="propsDefs['guruHelpCenterSourceEnabled'].title" :description="propsDefs['guruHelpCenterSourceEnabled'].description">
              <div class="col-span-full mt-4 border-l-2 border-indigo-100 pl-4">
                <StdPropEditor v-model="guruCollectionIds" style="display: none" class="col-span-4 mt-2" :prop-def="propsDefs['guruCollectionIds']" />
                <MultiSelect
                  v-model="guruCollectionIdsSelected"
                  :options="guruCollections"
                  option-label="name"
                  option-value="id"
                  :placeholder="loadingGuruCollections ? '⏳ Loading...' : 'Select Collections'"
                  :loading="loadingGuruCollections"
                  :disabled="loadingGuruCollections"
                  :max-selected-labels="3"
                  class="w-full"
                />
                <StdPropEditor v-model="guruHelpCentersTags" class="col-span-4 mt-2" :prop-def="propsDefs['guruHelpCentersTags']" />
                <StdPropEditor v-model="guruPrivateArticlesEnabled" class="col-span-4 mt-2" :prop-def="propsDefs['guruPrivateArticlesEnabled']" />
              </div>
              <div class="col-span-full flex items-center justify-end gap-x-2 border-l-2 border-indigo-100 pl-4 pt-6">
                <Button label="Reload all" icon="pi pi-cloud-download" severity="secondary" :disabled="!guruCollectionIdsSelected.length" @click="onDownloadGuruHelpCenters(true)" />
                <Button icon="pi pi-cloud-download" label="Load Updates" :disabled="!guruCollectionIdsSelected.length" @click="onDownloadGuruHelpCenters(false)" />
              </div>
            </ToggleGroup>
          </div>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-8 pt-6 md:grid-cols-5">
      <div class="relative px-4 sm:px-0">
        <div>
          <h2 class="text-base font-semibold leading-7 text-gray-900">Advanced</h2>
          <p class="mt-1 text-sm leading-6 text-gray-600">Show advanced options</p>
        </div>
      </div>
      <div class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-4">
        <div class="px-4 py-2">
          <div class="grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-6">
            <div class="col-span-full">
              <ToggleGroup v-model="advancedEnabled" name="Advanced" description="">
                <StdPropEditor v-model="mode" class="col-span-4 mt-2" :prop-def="propsDefs['mode']" />
                <StdPropEditor v-model="embeddingModel" class="col-span-4 mt-4" :prop-def="propsDefs['embeddingModel']" />
                <StdPropEditor v-model="vectorStore" class="col-span-4 mt-4" :prop-def="propsDefs['vectorStore']" />
                <StdPropEditor v-model="splitSizeThreshold" class="col-span-4 mt-4" :prop-def="propsDefs['splitSizeThreshold']" />
                <StdPropEditor v-model="splitOptions" class="col-span-4 mt-4" :prop-def="propsDefs['splitOptions']" />
                <StdPropEditor v-model="semanticSplitModelName" class="col-span-4 mt-4" :prop-def="propsDefs['semanticSplitModelName']" />
                <StdPropEditor v-model="semanticSplitInstructions" class="col-span-4 mt-4" :prop-def="propsDefs['semanticSplitInstructions']" />
                <StdPropEditor v-model="maxKbSearchDocuments" class="col-span-4 mt-4" :prop-def="propsDefs['maxKbSearchDocuments']" />
                <StdPropEditor v-model="searchByKeywordsEnabled" class="col-span-4 mt-4" :prop-def="propsDefs['searchByKeywordsEnabled']" />
                <StdPropEditor v-if="kbStore.contentPublishingEnabled" v-model="publishMethod" class="col-span-4 mt-4" :prop-def="propsDefs['publishMethod']" />
                <StdPropEditor v-if="kbStore.contentPublishingEnabled" v-model="ignoreDocumentErrorsOnPublish" class="col-span-4 mt-4" :prop-def="propsDefs['ignoreDocumentErrorsOnPublish']" />
                <StdPropEditor v-if="publishMethod === 'ai'" v-model="contentPublisherModelName" class="col-span-4 mt-4" :prop-def="propsDefs['contentPublisherModelName']" />
                <StdPropEditor v-if="publishMethod === 'ai'" v-model="publishAnalyzerInstructions" class="col-span-4 mt-4" :prop-def="propsDefs['publishAnalyzerInstructions']" />
                <StdPropEditor v-model="contentFilterAI" class="col-span-4 mt-4" :prop-def="propsDefs['contentFilterAI']" />
                <StdPropEditor v-model="extractTextFromImages" class="col-span-4 mt-4" :prop-def="propsDefs['extractTextFromImages']" />
                <StdPropEditor v-model="purgeDeletedDocumentsEnabled" class="col-span-4 mt-4" :prop-def="propsDefs['purgeDeletedDocumentsEnabled']" />
                <StdPropEditor v-if="purgeDeletedDocumentsEnabled" v-model="purgeDeletedEnabledWarning" class="col-span-4 mt-4" :prop-def="propsDefs['purgeDeletedEnabledWarning']" />
                <StdPropEditor
                  v-if="settingsStore.salesforceIntegrationEnabled && salesforceHelpCenterSourceEnabled"
                  v-model="salesforceHelpCenterSourceRefreshInterval"
                  class="col-span-4 mt-4"
                  :prop-def="propsDefs['salesforceHelpCenterSourceRefreshInterval']"
                />
                <!-- [sv2] DO NOT CHECK settingsStore.zendeskIntegrationEnabled here. Loading from Zendesk HC can be done without enabling integration, via pulick API -->
                <StdPropEditor v-if="zendeskHelpCenterSourceEnabled" v-model="zendeskHelpCenterSourceRefreshInterval" class="col-span-4 mt-4" :prop-def="propsDefs['zendeskHelpCenterSourceRefreshInterval']" />

                <StdPropEditor
                  v-if="settingsStore.shopifyIntegrationEnabled && shopifyHelpCenterSourceEnabled"
                  v-model="shopifyHelpCenterSourceRefreshInterval"
                  class="col-span-4 mt-4"
                  :prop-def="propsDefs['shopifyHelpCenterSourceRefreshInterval']"
                />

                <StdPropEditor
                  v-if="settingsStore.kustomerIntegrationEnabled && kustomerHelpCenterSourceEnabled"
                  v-model="kustomerHelpCenterSourceRefreshInterval"
                  class="col-span-4 mt-4"
                  :prop-def="propsDefs['kustomerHelpCenterSourceRefreshInterval']"
                />
                <StdPropEditor
                  v-if="settingsStore.gorgiasIntegrationEnabled && gorgiasHelpCenterSourceEnabled"
                  v-model="gorgiasHelpCenterSourceRefreshInterval"
                  class="col-span-4 mt-4"
                  :prop-def="propsDefs['gorgiasHelpCenterSourceRefreshInterval']"
                />
                <StdPropEditor
                  v-if="settingsStore.intercomIntegrationEnabled && intercomHelpCenterSourceEnabled"
                  v-model="intercomHelpCenterSourceRefreshInterval"
                  class="col-span-4 mt-4"
                  :prop-def="propsDefs['intercomHelpCenterSourceRefreshInterval']"
                />
                <StdPropEditor
                  v-if="settingsStore.confluenceIntegrationEnabled && confluenceHelpCenterSourceEnabled"
                  v-model="confluenceHelpCenterSourceRefreshInterval"
                  class="col-span-4 mt-4"
                  :prop-def="propsDefs['confluenceHelpCenterSourceRefreshInterval']"
                />
                <StdPropEditor
                  v-if="settingsStore.guruIntegrationEnabled && guruHelpCenterSourceEnabled"
                  v-model="guruHelpCenterSourceRefreshInterval"
                  class="col-span-4 mt-4"
                  :prop-def="propsDefs['guruHelpCenterSourceRefreshInterval']"
                />
                <StdPropEditor
                  v-if="settingsStore.freshdeskIntegrationEnabled && freshdeskHelpCenterSourceEnabled"
                  v-model="freshdeskHelpCenterSourceRefreshInterval"
                  class="col-span-4 mt-4"
                  :prop-def="propsDefs['freshdeskHelpCenterSourceRefreshInterval']"
                />
              </ToggleGroup>
            </div>
          </div>
        </div>
      </div>
    </div>
    <KbDialogDownloadZendeskHelpCenter ref="dialogDownloadZendeskHelpCenter"></KbDialogDownloadZendeskHelpCenter>
    <KbDialogDownloadSalesforceHelpCenter ref="dialogDownloadSalesforceHelpCenter"></KbDialogDownloadSalesforceHelpCenter>
    <KbDialogDownloadFreshdeskHelpCenter ref="dialogDownloadFreshdeskHelpCenter"></KbDialogDownloadFreshdeskHelpCenter>
    <KbDialogDownloadShopifyHelpCenter ref="dialogDownloadShopifyHelpCenter"></KbDialogDownloadShopifyHelpCenter>
    <KbDialogDownloadKustomerHelpCenter ref="dialogDownloadKustomerHelpCenter"></KbDialogDownloadKustomerHelpCenter>
    <KbDialogDownloadGorgiasHelpCenter ref="dialogDownloadGorgiasHelpCenter"></KbDialogDownloadGorgiasHelpCenter>
    <KbDialogDownloadIntercomHelpCenter ref="dialogDownloadIntercomHelpCenter"></KbDialogDownloadIntercomHelpCenter>
    <KbDialogDownloadConfluenceHelpCenter ref="dialogDownloadConfluenceHelpCenter"></KbDialogDownloadConfluenceHelpCenter>
    <KbDialogDownloadGuruHelpCenter ref="dialogDownloadGuruHelpCenter"></KbDialogDownloadGuruHelpCenter>
  </div>
</template>

<script setup>
  import { computed, ref, watch, onMounted, onActivated, nextTick } from 'vue';

  import { useKbStore } from '@/store/KbStore';
  import { useSettingsStore } from '@/store/SettingsStore';
  import { useToast } from 'vue-toastification';
  import ToggleGroup from '@/components/Toggles/ToggleGroup.vue';
  import InputTextarea from '@/components/Bots/editors/InputTextarea.vue';
  import { KB_TYPE_DEFS } from '@/spec/KbTypeDefs';
  import StdPropEditor from '@/components/Editors/StdPropEditor.vue';
  import StdTagInputEditor from '@/components/Editors/StdTagInputEditor.vue';
  import Button from 'primevue/button';
  import KbDialogDownloadZendeskHelpCenter from '@/components/KB/dialogs/KbDialogDownloadZendeskHelpCenter.vue';
  import KbDialogDownloadSalesforceHelpCenter from '@/components/KB/dialogs/KbDialogDownloadSalesforceHelpCenter.vue';
  import KbDialogDownloadFreshdeskHelpCenter from '@/components/KB/dialogs/KbDialogDownloadFreshdeskHelpCenter.vue';
  import KbDialogDownloadShopifyHelpCenter from '@/components/KB/dialogs/KbDialogDownloadShopifyHelpCenter.vue';
  import KbDialogDownloadKustomerHelpCenter from '@/components/KB/dialogs/KbDialogDownloadKustomerHelpCenter.vue';
  import KbDialogDownloadGorgiasHelpCenter from '@/components/KB/dialogs/KbDialogDownloadGorgiasHelpCenter.vue';
  import KbDialogDownloadIntercomHelpCenter from '@/components/KB/dialogs/KbDialogDownloadIntercomHelpCenter.vue';
  import KbDialogDownloadConfluenceHelpCenter from '@/components/KB/dialogs/KbDialogDownloadConfluenceHelpCenter.vue';
  import KbDialogDownloadGuruHelpCenter from '@/components/KB/dialogs/KbDialogDownloadGuruHelpCenter.vue';
  import dayjs from 'dayjs';
  import MultiSelect from 'primevue/multiselect';
  import { useApi } from '@/hooks/useApi';
  import Dropdown from 'primevue/dropdown';

  const api = useApi();

  const kbStore = useKbStore();
  const settingsStore = useSettingsStore();
  const toast = useToast();

  const dialogDownloadZendeskHelpCenter = ref(null);
  const dialogDownloadSalesforceHelpCenter = ref(null);
  const dialogDownloadFreshdeskHelpCenter = ref(null);
  const dialogDownloadShopifyHelpCenter = ref(null);
  const dialogDownloadKustomerHelpCenter = ref(null);
  const dialogDownloadGorgiasHelpCenter = ref(null);
  const dialogDownloadIntercomHelpCenter = ref(null);
  const dialogDownloadConfluenceHelpCenter = ref(null);
  const dialogDownloadGuruHelpCenter = ref(null);

  // todo show based on user role
  const advancedEnabled = ref(false);

  const propsDefs = KB_TYPE_DEFS['standard']?.propsByName || {};

  const specName = computed(kbStore.getKbSpecPropGetSet('name'));
  const specDescription = computed(kbStore.getKbSpecPropGetSet('description'));
  const specTags = computed(kbStore.getKbSpecPropGetSet('tags'));

  const webSourceEnabled = computed(kbStore.getKbSpecPropGetSet('webSourceEnabled'));
  const sitemaps = computed(kbStore.getKbSpecPropGetSet('sitemaps'));
  const urls = computed(kbStore.getKbSpecPropGetSet('urls'));

  const fieldsByObjectTypeMap = ref({});

  async function fetchFieldsForObject(typeName) {
    if (!fieldsByObjectTypeMap.value[typeName]) {
      const { data } = await api.salesforceGetFieldsByObjectType({ objectType: typeName });
      fieldsByObjectTypeMap.value[typeName] = data;
    }
    return fieldsByObjectTypeMap.value[typeName];
  }

  async function changeObjectType(item) {
    const FBOT = await fetchFieldsForObject(item.objectType);
    const mapping = {};
    requiredFieldTypes.value.forEach((f) => {
      mapping[f.name] = FBOT.find((fb) => fb.name === f.name) ? f.name : '';
    });
    item.fieldsMapping = mapping;
  }

  function deleteFieldFromMapping(item, type) {
    if (item.fieldsMapping && item.fieldsMapping[type] !== undefined) {
      delete item.fieldsMapping[type];
    }
  }

  function fieldsMappingArray(item) {
    return Object.entries(item.fieldsMapping || {}).map(([type, field]) => ({ type, field }));
  }
  const contactFormFields = computed(kbStore.getKbSpecPropGetSet('salesforceHelpCenterCustomFields'));

  const salesforceFieldMapperEnabledManual = ref(contactFormFields?.value?.length > 0);

  watch(
    contactFormFields,
    (val) => {
      if (val && val.length > 0) {
        salesforceFieldMapperEnabledManual.value = true;
        const seen = new Set();
        val.forEach((item) => {
          if (item.objectType && !seen.has(item.objectType)) {
            seen.add(item.objectType);
            fetchFieldsForObject(item.objectType);
          }
        });
      }
    },
    { deep: true, immediate: true },
  );

  const salesforceFieldMapperEnabled = computed({
    get() {
      return salesforceFieldMapperEnabledManual.value;
    },
    set(val) {
      salesforceFieldMapperEnabledManual.value = val;
      if (!val || (val && !Array.isArray(contactFormFields.value))) {
        contactFormFields.value = [];
      }
    },
  });
  const requiredFieldTypes = ref([]);
  const optionalFieldTypes = ref([]);
  const allObjects = ref([]);

  watch(
    () => salesforceFieldMapperEnabled.value,
    (val) => {
      if (val) {
        api.salesforceGetKnowledgeArticleFieldTypes().then(({ data: { knowledgeArticleFieldTypes, knowledgeArticleFieldTypesRequired } }) => {
          const req = [];
          const opt = [];

          knowledgeArticleFieldTypes.forEach((field) => {
            if (knowledgeArticleFieldTypesRequired.includes(field.name)) {
              req.push(field);
            } else {
              opt.push(field);
            }
          });
          requiredFieldTypes.value = req;
          optionalFieldTypes.value = opt;
        });

        api.salesforceGetAllObjects().then(({ data }) => {
          allObjects.value = data.map((o) => ({
            ...o,
            searchableLabel: `${o.label} ${o.name}`,
          }));
        });
      }
    },{ deep: true, immediate: true },
  );

  async function addContactFormField() {
    const FBOT = await fetchFieldsForObject(allObjects.value[contactFormFields.value.length].name);
    const mapping = {};
    requiredFieldTypes.value.forEach((f) => {
      mapping[f.name] = FBOT.find((fb) => fb.name === f.name) ? f.name : '';
    });
    contactFormFields.value.push({
      objectType: allObjects.value[contactFormFields.value.length].name,
      fieldsMapping: mapping,
    });
  }

  function addOptionalField(item, count) {
    const optionalAdded = fieldsMappingArray(item).slice(requiredFieldTypes.value.length);
    const firstOptional = optionalFieldTypes.value.filter(oft=> !optionalAdded.find(oa=> oa.type === oft.name))[0];
    if (!(firstOptional.name in item.fieldsMapping)) {
      item.fieldsMapping[firstOptional.name] = fieldsByObjectTypeMap.value[item.objectType].find((fb) => fb.name === firstOptional.name) ? firstOptional.name : '';
    }
  }

  watch(
    () => contactFormFields.value,
    (val) => {
      console.log(val);
    },
    { deep: true },
  );



  const salesforceHelpCenterSourceEnabled = computed(kbStore.getKbSpecPropGetSet('salesforceHelpCenterSourceEnabled'));
  const salesforceHelpCenterSourceRefreshInterval = computed(kbStore.getKbSpecPropGetSet('salesforceHelpCenterSourceRefreshInterval'));
  const salesforceHelpCenterRecordTypes = computed(kbStore.getKbSpecPropGetSet('salesforceHelpCenterRecordTypes'));
  const hcRecordTypes = ref(['FAQ', 'Procedure']);
  const hcRecordTypesSelected = computed({
    get() {
      return (salesforceHelpCenterRecordTypes.value || '').split(', ').filter(Boolean);
    },
    set(val) {
      salesforceHelpCenterRecordTypes.value = val.filter(Boolean).join(', ');
    },
  });
  const salesforcePrivateArticlesEnabled = computed(kbStore.getKbSpecPropGetSet('salesforcePrivateArticlesEnabled'));

  const shopifyCustomCode = computed(kbStore.getKbSpecPropGetSet('shopifyCustomCode'));
  const shopifyHelpCenterSourceEnabled = computed(kbStore.getKbSpecPropGetSet('shopifyHelpCenterSourceEnabled'));
  const shopifyHelpCenterSourceRefreshInterval = computed(kbStore.getKbSpecPropGetSet('shopifyHelpCenterSourceRefreshInterval'));
  const shopifyHelpCenterRecordTypes = computed(kbStore.getKbSpecPropGetSet('shopifyHelpCenterRecordTypes'));
  const shopifyRecordTypes = ref(['Articles', 'Products']);
  const shopifyRecordTypesSelected = computed({
    get() {
      return (shopifyHelpCenterRecordTypes.value || '').split(', ').filter(Boolean);
    },
    set(val) {
      shopifyHelpCenterRecordTypes.value = val.filter(Boolean).join(', ');
    },
  });
  const loadingShopifyProducts = ref(false);
  const shopifyProducts = ref([]);
  const shopifyProductMetafieldDefinitions = computed(kbStore.getKbSpecPropGetSet('shopifyProductMetafieldDefinitions'));
  const shopifyProductMetafieldDefinitionsSelected = computed({
    get() {
      return (shopifyProductMetafieldDefinitions.value || '')
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean)
        .map((val) => {
          const [namespace, key] = val.split('.');
          const item = shopifyProducts?.value?.find((opt) => opt.namespace === namespace && opt.key === key);
          return item ? item.name : null;
        })
        .filter(Boolean);
    },
    set(val) {
      shopifyProductMetafieldDefinitions.value = val
        .map((name) => {
          const item = shopifyProducts?.value?.find((opt) => opt.name === name);
          return item ? `${item.namespace}.${item.key}` : null;
        })
        .filter(Boolean)
        .join(',');
    },
  });

  // allow manual toggling independently of custom code content
  const shopifyHelpCenterSourceCodeEnabledManual = ref(Boolean(shopifyCustomCode.value));
  watch(shopifyCustomCode, (val) => {
    if (val) {
      shopifyHelpCenterSourceCodeEnabledManual.value = true;
    }
  });

  const shopifyHelpCenterSourceCodeEnabled = computed({
    get() {
      return shopifyHelpCenterSourceCodeEnabledManual.value;
    },
    set(val) {
      shopifyHelpCenterSourceCodeEnabledManual.value = val;
      if (!val) {
        shopifyCustomCode.value = '';
      }
    },
  });

  watch(
    () => shopifyHelpCenterSourceCodeEnabled.value,
    (val) => {
      if (val) {
        api
          .shopifyConvertToScript({
            shopifyHelpCenterRecordTypes: shopifyHelpCenterRecordTypes.value,
            shopifyProductMetafieldDefinitions: shopifyProductMetafieldDefinitions.value,
            shopifyProductSalesChannels: shopifyProductSalesChannels.value,
          })
          .then((result) => {
            shopifyCustomCode.value = result.data;
          });
      }
    },
  );
  const loadingShopifyProductSalesChannels = ref(false);
  const productSalesChannels = ref([]);
  const shopifyProductSalesChannels = computed(kbStore.getKbSpecPropGetSet('shopifyProductSalesChannels'));
  const shopifyProductSalesChannelsSelected = computed({
    get() {
      return (shopifyProductSalesChannels.value || '').split(',').filter(Boolean);
    },
    set(val) {
      shopifyProductSalesChannels.value = val.join(',');
    },
  });

  // const shopifyPrivateArticlesEnabled = computed(kbStore.getKbSpecPropGetSet('shopifyPrivateArticlesEnabled'));

  const zendeskHelpCenterSourceEnabled = computed(kbStore.getKbSpecPropGetSet('zendeskHelpCenterSourceEnabled'));
  const zendeskHelpCenterSourceRefreshInterval = computed(kbStore.getKbSpecPropGetSet('zendeskHelpCenterSourceRefreshInterval'));
  const zendeskHelpCentersSubdomains = computed(kbStore.getKbSpecPropGetSet('zendeskHelpCentersSubdomains'));
  const zendeskPrivateArticlesEnabled = computed(kbStore.getKbSpecPropGetSet('zendeskPrivateArticlesEnabled'));

  const kustomerHelpCenterSourceEnabled = computed(kbStore.getKbSpecPropGetSet('kustomerHelpCenterSourceEnabled'));
  const kustomerHelpCenterSourceRefreshInterval = computed(kbStore.getKbSpecPropGetSet('kustomerHelpCenterSourceRefreshInterval'));
  const kustomerPrivateArticlesEnabled = computed(kbStore.getKbSpecPropGetSet('kustomerPrivateArticlesEnabled'));

  const gorgiasHelpCenterSourceEnabled = computed(kbStore.getKbSpecPropGetSet('gorgiasHelpCenterSourceEnabled'));
  const gorgiasHelpCenterSourceRefreshInterval = computed(kbStore.getKbSpecPropGetSet('gorgiasHelpCenterSourceRefreshInterval'));
  const gorgiasHelpCentersSubdomains = computed(kbStore.getKbSpecPropGetSet('gorgiasHelpCentersSubdomains'));

  const intercomHelpCenterSourceEnabled = computed(kbStore.getKbSpecPropGetSet('intercomHelpCenterSourceEnabled'));
  const intercomHelpCenterSourceRefreshInterval = computed(kbStore.getKbSpecPropGetSet('intercomHelpCenterSourceRefreshInterval'));

  const confluenceHelpCenterSourceEnabled = computed(kbStore.getKbSpecPropGetSet('confluenceHelpCenterSourceEnabled'));
  const confluenceSpaceKeys = computed(kbStore.getKbSpecPropGetSet('confluenceSpaceKeys'));
  const confluenceLabels = computed(kbStore.getKbSpecPropGetSet('confluenceLabels'));
  const confluenceHelpCenterSourceRefreshInterval = computed(kbStore.getKbSpecPropGetSet('confluenceHelpCenterSourceRefreshInterval'));

  const guruHelpCenterSourceEnabled = computed(kbStore.getKbSpecPropGetSet('guruHelpCenterSourceEnabled'));
  const guruCollectionIds = computed(kbStore.getKbSpecPropGetSet('guruCollectionIds'));
  const guruHelpCentersTags = computed(kbStore.getKbSpecPropGetSet('guruHelpCentersTags'));
  const guruPrivateArticlesEnabled = computed(kbStore.getKbSpecPropGetSet('guruPrivateArticlesEnabled'));
  const guruHelpCenterSourceRefreshInterval = computed(kbStore.getKbSpecPropGetSet('guruHelpCenterSourceRefreshInterval'));

  const loadingGuruCollections = ref(false);
  const guruCollections = ref([]);
  const guruCollectionIdsSelected = computed({
    get() {
      return (guruCollectionIds.value || '').split(',').filter(Boolean);
    },
    set(val) {
      guruCollectionIds.value = val.join(',');
    },
  });

  const freshdeskHelpCenterSourceEnabled = computed(kbStore.getKbSpecPropGetSet('freshdeskHelpCenterSourceEnabled'));
  const freshdeskHelpCenterSourceRefreshInterval = computed(kbStore.getKbSpecPropGetSet('freshdeskHelpCenterSourceRefreshInterval'));
  const freshdeskCategoryIds = computed(kbStore.getKbSpecPropGetSet('freshdeskCategoryIds'));
  const freshdeskHelpCenterTags = computed(kbStore.getKbSpecPropGetSet('freshdeskHelpCenterTags'));
  const freshdeskIncludeDrafts = computed(kbStore.getKbSpecPropGetSet('freshdeskIncludeDrafts'));

  const loadingFreshdeskCategories = ref(false);
  const freshdeskCategories = ref([]);
  const freshdeskCategoryIdsSelected = computed({
    get() {
      return (freshdeskCategoryIds.value || '').split(',').filter(Boolean);
    },
    set(val) {
      freshdeskCategoryIds.value = val.join(',');
    },
  });

  const mode = computed(kbStore.getKbSpecPropGetSet('mode'));
  const embeddingModel = computed(kbStore.getKbSpecPropGetSet('embeddingModel'));
  const vectorStore = computed(kbStore.getKbSpecPropGetSet('vectorStore'));
  const splitSizeThreshold = computed(kbStore.getKbSpecPropGetSet('splitSizeThreshold'));
  const splitOptions = computed(kbStore.getKbSpecPropGetSet('splitOptions'));
  const semanticSplitModelName = computed(kbStore.getKbSpecPropGetSet('semanticSplitModelName'));
  const semanticSplitInstructions = computed(kbStore.getKbSpecPropGetSet('semanticSplitInstructions'));
  const maxKbSearchDocuments = computed(kbStore.getKbSpecPropGetSet('maxKbSearchDocuments'));
  const searchByKeywordsEnabled = computed(kbStore.getKbSpecPropGetSet('searchByKeywordsEnabled'));
  const purgeDeletedDocumentsEnabled = computed(kbStore.getKbSpecPropGetSet('purgeDeletedDocumentsEnabled'));
  const extractTextFromImages = computed(kbStore.getKbSpecPropGetSet('extractTextFromImages'));
  const publishMethod = computed(kbStore.getKbSpecPropGetSet('publishMethod'));
  const contentPublisherModelName = computed(kbStore.getKbSpecPropGetSet('contentPublisherModelName'));
  const publishAnalyzerInstructions = computed(kbStore.getKbSpecPropGetSet('publishAnalyzerInstructions'));
  const contentFilterAI = computed(kbStore.getKbSpecPropGetSet('contentFilterAI'));
  const ignoreDocumentErrorsOnPublish = computed(kbStore.getKbSpecPropGetSet('ignoreDocumentErrorsOnPublish'));

  function loadShopifyProductsData() {
    loadingShopifyProducts.value = true;
    api.shopifyGetAllProductMetafieldDefinitions({}).then(({ data }) => {
      loadingShopifyProducts.value = false;
      shopifyProducts.value = data;
    });
  }

  function loadGuruCollectionsData() {
    loadingGuruCollections.value = true;
    api
      .guruGetCollections({})
      .then(({ data }) => {
        loadingGuruCollections.value = false;
        guruCollections.value = data || [];
        // Select all collections by default if none are currently selected
        if (!guruCollectionIds.value && Array.isArray(data) && data.length > 0) {
          guruCollectionIds.value = data.map((collection) => collection.id).join(',');
        }
      })
      .catch((error) => {
        loadingGuruCollections.value = false;
        console.error('Failed to load Guru collections:', error);
        toast.error('Failed to load Guru collections');
      });
  }

  function loadFreshdeskCategoriesData() {
    loadingFreshdeskCategories.value = true;
    api
      .freshdeskGetSolutionCategories({})
      .then(({ data }) => {
        loadingFreshdeskCategories.value = false;
        freshdeskCategories.value = data || [];
        // Select all categories by default if none are currently selected
        if (!freshdeskCategoryIds.value && Array.isArray(data) && data.length > 0) {
          freshdeskCategoryIds.value = data.map((category) => category.id).join(',');
        }
      })
      .catch((error) => {
        loadingFreshdeskCategories.value = false;
        console.error('Failed to load Freshdesk categories:', error);
        toast.error('Failed to load Freshdesk categories');
      });
  }

  function loadShopifyyGetProductSalesChannelsData() {
    loadingShopifyProductSalesChannels.value = true;
    api.shopifyGetProductSalesChannels({}).then(({ data = [] }) => {
      loadingShopifyProductSalesChannels.value = false;
      productSalesChannels.value = data;
      if (!shopifyProductSalesChannels.value) {
        shopifyProductSalesChannels.value = data.map((item) => item.id).join(',');
      }
    });
  }

  function triggerLoadShopify() {
    if (shopifyRecordTypesSelected.value.includes('Products')) {
      loadShopifyProductsData();
    }
    loadShopifyyGetProductSalesChannelsData();
  }

  function triggerLoadGuru() {
    if (settingsStore.guruIntegrationEnabled) {
      loadGuruCollectionsData();
    }
  }

  function triggerLoadFreshdesk() {
    if (settingsStore.freshdeskIntegrationEnabled) {
      loadFreshdeskCategoriesData();
    }
  }

  watch(shopifyRecordTypesSelected, (val) => {
    if (val.includes('Products')) {
      loadShopifyProductsData();
    }
  });
  onMounted(() => {
    Promise.all([Promise.resolve().then(triggerLoadShopify), Promise.resolve().then(triggerLoadFreshdesk), Promise.resolve().then(triggerLoadGuru)]);
  });
  onActivated(() => {
    Promise.all([Promise.resolve().then(triggerLoadShopify), Promise.resolve().then(triggerLoadFreshdesk), Promise.resolve().then(triggerLoadGuru)]);
  });

  function onKbAddTag(tag) {
    kbStore.addTagToKb(tag);
  }

  async function checkSaveKb() {
    if (!kbStore.kbIsChanged) {
      return true;
    }

    const saveRes = await kbStore.saveKb();
    if (!saveRes) {
      toast.error(`Error saving KB`);
      return false;
    }
    toast.success('KB saved successfully');
    return true;
  }

  async function onDownloadZendeskHelpCenters(reloadAll = false) {
    const checkSaveRes = await checkSaveKb();
    if (!checkSaveRes) {
      return;
    }
    const kb = kbStore.getKb(kbStore.kbId);
    const lastUpdate = kb?.zendeskHelpCenterLastUpdated || null;
    const lastUpdateDate = lastUpdate ? dayjs(lastUpdate).format() : null;

    const subdomains = (kbStore.kbSpec?.zendeskHelpCentersSubdomains || '').split(',').map((x) => x.trim());
    dialogDownloadZendeskHelpCenter.value.start(reloadAll, subdomains, lastUpdateDate);
  }

  async function onDownloadSalesforceHelpCenters(reloadAll = false) {
    const checkSaveRes = await checkSaveKb();
    if (!checkSaveRes) {
      return;
    }
    const kb = kbStore.getKb(kbStore.kbId);
    const lastUpdate = kb?.salesforceHelpCenterLastUpdated || null;
    const lastUpdateDate = lastUpdate ? dayjs(lastUpdate).format() : null;

    const recordTypes = (kbStore.kbSpec?.salesforceHelpCenterRecordTypes || '').split(',').map((x) => x.trim());
    dialogDownloadSalesforceHelpCenter.value.start(reloadAll, recordTypes, lastUpdateDate, !!contactFormFields.value.length);
  }

  async function onDownloadShopifyHelpCenters(reloadAll = false) {
    const checkSaveRes = await checkSaveKb();
    if (!checkSaveRes) {
      return;
    }
    const kb = kbStore.getKb(kbStore.kbId);
    const lastUpdate = kb?.shopifyHelpCenterLastUpdated || null;
    const lastUpdateDate = lastUpdate ? dayjs(lastUpdate).format() : null;

    const recordTypes = (kbStore.kbSpec?.shopifyHelpCenterRecordTypes || '').split(',').map((x) => x.trim());
    const products = shopifyProductMetafieldDefinitionsSelected.value;
    dialogDownloadShopifyHelpCenter.value.start(reloadAll, recordTypes, lastUpdateDate, products, shopifyCustomCode.value);
  }

  async function onDownloadKustomerHelpCenters(reloadAll = false) {
    const checkSaveRes = await checkSaveKb();
    if (!checkSaveRes) {
      return;
    }
    const kb = kbStore.getKb(kbStore.kbId);
    const lastUpdate = kb?.kustomerHelpCenterLastUpdated || null;
    const lastUpdateDate = lastUpdate ? dayjs(lastUpdate).format() : null;

    dialogDownloadKustomerHelpCenter.value.start(reloadAll, lastUpdateDate);
  }

  async function onDownloadGorgiasHelpCenters(reloadAll = false) {
    const checkSaveRes = await checkSaveKb();
    if (!checkSaveRes) {
      return;
    }
    const kb = kbStore.getKb(kbStore.kbId);
    const lastUpdate = kb?.gorgiasHelpCenterLastUpdated || null;
    const lastUpdateDate = lastUpdate ? dayjs(lastUpdate).format() : null;

    const subdomains = (kbStore.kbSpec?.gorgiasHelpCentersSubdomains || '').split(',').map((x) => x.trim());
    dialogDownloadGorgiasHelpCenter.value.start(reloadAll, subdomains, lastUpdateDate);
  }

  async function onDownloadIntercomHelpCenters(reloadAll = false) {
    const checkSaveRes = await checkSaveKb();
    if (!checkSaveRes) {
      return;
    }

    const kb = kbStore.getKb(kbStore.kbId);
    const lastUpdate = kb?.intercomHelpCenterLastUpdated || null;
    const lastUpdateDate = lastUpdate ? dayjs(lastUpdate).format() : null;

    dialogDownloadIntercomHelpCenter.value.start(reloadAll, lastUpdateDate);
  }

  async function onDownloadConfluenceHelpCenters(reloadAll = false) {
    const checkSaveRes = await checkSaveKb();
    if (!checkSaveRes) {
      return;
    }

    const kb = kbStore.getKb(kbStore.kbId);
    const lastUpdate = kb?.confluenceHelpCenterLastUpdated || null;
    const lastUpdateDate = lastUpdate ? dayjs(lastUpdate).format() : null;

    dialogDownloadConfluenceHelpCenter.value.start(reloadAll, lastUpdateDate);
  }

  async function onDownloadGuruHelpCenters(reloadAll = false) {
    const checkSaveRes = await checkSaveKb();
    if (!checkSaveRes) {
      return;
    }

    const kb = kbStore.getKb(kbStore.kbId);
    const lastUpdate = kb?.guruHelpCenterLastUpdated || null;
    const lastUpdateDate = lastUpdate ? dayjs(lastUpdate).format() : null;

    dialogDownloadGuruHelpCenter.value.start(reloadAll, lastUpdateDate);
  }

  async function onDownloadFreshdeskHelpCenters(reloadAll = false) {
    const checkSaveRes = await checkSaveKb();
    if (!checkSaveRes) {
      return;
    }
    const kb = kbStore.getKb(kbStore.kbId);
    const lastUpdate = kb?.freshdeskHelpCenterLastUpdated || null;
    const lastUpdateDate = lastUpdate ? dayjs(lastUpdate).format() : null;

    const categoryIds = freshdeskCategoryIdsSelected.value;
    // Get category names for display
    const categoryNames = categoryIds.map((id) => {
      const category = freshdeskCategories.value.find((cat) => cat.id === id);
      return category ? category.name : `Category ${id}`;
    });

    const tags = freshdeskHelpCenterTags.value;

    dialogDownloadFreshdeskHelpCenter.value.start(reloadAll, categoryIds, categoryNames, tags, lastUpdateDate);
  }
</script>
